export default __webpack_public_path__ + "static/media/20-min.883ef135.jpg";